import type React from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createActionsHook,
	type Action,
} from '@atlassian/react-sweet-state';

type RovoButtonNodeState = { node: React.ReactNode | null };

const actions = {
	setNode:
		(node: React.ReactNode | null): Action<RovoButtonNodeState> =>
		({ setState }) => {
			setState({ node });
		},
} as const;

const store = createStore<RovoButtonNodeState, typeof actions>({
	name: 'RovoButtonNodeState',
	initialState: { node: null },
	actions,
});

export const useRovoButtonNode = createHook<
	RovoButtonNodeState,
	typeof actions,
	React.ReactNode | null,
	undefined
>(store, { selector: (state) => state.node });

export const useRovoButtonNodeActions = createActionsHook(store);
